import { z } from "zod";

export const AvailableLanguagesValues = [
  "en",
  "enBtp",
  "enColp",
  "enMet",
] as const;

export const AvailableLanguagesSchema = z.enum({
  English: "en",
  BritishTransportPolice: "enBtp",
  CityOfLondonPolice: "enColp",
  MetropolitanPolice: "enMet",
} satisfies Record<string, (typeof AvailableLanguagesValues)[number]>);

export type AvailableLanguages = (typeof AvailableLanguagesValues)[number];
